import React from 'react';
import { StyleProp, TextStyle, Text } from 'react-native';
import { WebLink } from '../VoyoConsentDialog/WebLink';

export type ParsedText = [
    hasHyperlink: boolean,
    textLink: string,
    textLinkName: string,
    textBeforeLink: string,
    textAfterLink: string
];

export const parseURLString = (text: string): ParsedText => {
    if (text.includes('(https://')) {
        const hasHyperlink = true;
        const textBeforeLink = text.substring(0, text.indexOf('['));
        const textLinkName = text.slice(text.indexOf('[') + 1, text.indexOf(']'));
        const textLink = text.slice(text.indexOf('(') + 1, text.indexOf(')'));
        const textAfterLink = text.substring(text.indexOf(')') + 1);
        return [hasHyperlink, textBeforeLink, textLinkName, textLink, textAfterLink];
    }
    return [false, text, '', '', ''];
};

export const parseMultipleURLStrings = (textIn: string): ParsedText[] => {
    let end = false;
    let text = textIn;

    const parsedText: ParsedText[] = [];
    while (!end) {
        const [hasHyperlink, textBeforeLink, textLinkName, textLink, textAfterLink] =
            parseURLString(text);
        parsedText.push([hasHyperlink, textBeforeLink, textLinkName, textLink, textAfterLink]);
        text = textAfterLink;

        if (!hasHyperlink) {
            end = true;
        }
    }
    return parsedText;
};

export const renderLinks = (text: string, style?: StyleProp<TextStyle>): Array<JSX.Element> => {
    const links = parseMultipleURLStrings(text);
    return links.map((item, index) => {
        const [hasHyperlink, textBeforeLink, textLinkName, textLink] = item;
        if (hasHyperlink) {
            return (
                <>
                    {textBeforeLink}
                    <WebLink key={index} url={textLink} text={textLinkName} style={style} />
                </>
            );
        }

        return <Text key={index}>{textBeforeLink}</Text>;
    });
};
